export default __webpack_public_path__ + "static/media/cost_pc.46dec835.png";